var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-overlay", { attrs: { show: _vm.is_load } }, [
        _c("form", { staticClass: "user", attrs: { autocomplete: "off" } }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "label",
                {
                  staticClass: "form-label",
                  attrs: { for: "input-live-feedback_username" },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.__t("TURBO_USERNAME")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("b-form-input", {
                staticClass: "form-control form-control-use",
                attrs: {
                  id: "input-live-feedback_username",
                  placeholder: _vm.__t("TURBO_USERNAME"),
                },
                model: {
                  value: _vm.turbo_sms.turbo_username,
                  callback: function ($$v) {
                    _vm.$set(_vm.turbo_sms, "turbo_username", $$v)
                  },
                  expression: "turbo_sms.turbo_username",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "label",
                {
                  staticClass: "form-label",
                  attrs: { for: "input-live-turbo_password" },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.__t("TURBO_PASSWORD")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("b-form-input", {
                staticClass: "form-control form-control-use",
                attrs: {
                  id: "input-live-turbo_password",
                  placeholder: _vm.__t("TURBO_PASSWORD"),
                },
                model: {
                  value: _vm.turbo_sms.turbo_password,
                  callback: function ($$v) {
                    _vm.$set(_vm.turbo_sms, "turbo_password", $$v)
                  },
                  expression: "turbo_sms.turbo_password",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "label",
                {
                  staticClass: "form-label",
                  attrs: { for: "input-live-turbo_alpha" },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.__t("TURBO_ALPHA")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("b-form-input", {
                staticClass: "form-control form-control-use",
                attrs: {
                  id: "input-live-turbo_alpha",
                  placeholder: _vm.__t("TURBO_ALPHA"),
                },
                model: {
                  value: _vm.turbo_sms.turbo_alpha,
                  callback: function ($$v) {
                    _vm.$set(_vm.turbo_sms, "turbo_alpha", $$v)
                  },
                  expression: "turbo_sms.turbo_alpha",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "panel-tag mt-3 mb-3" }, [
            _c("p", [_vm._v("{order_code}     - ORDER_CODE")]),
            _vm._v(" "),
            _c("p", [_vm._v("{rest_title}     - REST_TITLE")]),
            _vm._v(" "),
            _c("p", [_vm._v("{rest_phone}     - REST_PHONE")]),
            _vm._v(" "),
            _c("p", [_vm._v("{customer_name}  - CUSTOMER NAME")]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c(
                "label",
                {
                  staticClass: "form-label",
                  attrs: { for: "input-live-message" },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.__t("TURBO_SMS_TEXT")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("b-form-textarea", {
                attrs: {
                  id: "textarea",
                  placeholder: "SMS",
                  rows: "3",
                  "max-rows": "6",
                },
                model: {
                  value: _vm.turbo_sms.message,
                  callback: function ($$v) {
                    _vm.$set(_vm.turbo_sms, "message", $$v)
                  },
                  expression: "turbo_sms.message",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }